/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Error_DisconnectedInputs */



/**
* | output |
* | --- |
* | "Connection lost — data may be out of date." |
*
* @param {Sync_Error_DisconnectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sync_error_disconnected = /** @type {((inputs?: Sync_Error_DisconnectedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Error_DisconnectedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connexion perdue — les données peuvent être obsolètes.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Conexión perdida: los datos pueden estar desactualizados.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Conexão perdida — os dados podem estar desatualizados.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Connessione persa — i dati potrebbero non essere aggiornati.")
	return /** @type {LocalizedString} */ ("Connection lost — data may be out of date.")
});